import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import React from 'react'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import SmartviewText from '../partials/SmartviewText'
import SmartviewTextGroup from '../partials/SmartviewTextGroup'
import { Button, ButtonWrap } from '../../../ui'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import SmartviewContentSection from '../partials/SmartviewContentSection'

export function CheckupSmartview () {
  return (
    <Translator namespace='smartviews.checkups'>
      <Smartview header={<><Displays.Text name='department'/> - <Displays.Date name='completed_at'/></>}>
        <SmartviewContentSection>
          <SmartviewTextGroup highlight highlightSize='card'>
            <SmartviewText>
              <UI.SpaceBetween>
                <UI.Text color='black' size='base' className='mb-2'>
                  <Translation name='scores.excellent'/>
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right'>
                  <Displays.Text name='excellent'/>
                </UI.Text>
              </UI.SpaceBetween>
            </SmartviewText>
            <SmartviewText>
              <UI.SpaceBetween>
                <UI.Text color='black' size='base' className='mb-2'>
                  <Translation name='scores.ok'/>
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right'>
                  <Displays.Text name='ok'/>
                </UI.Text>
              </UI.SpaceBetween>
            </SmartviewText>
            <SmartviewText>
              <UI.SpaceBetween>
                <UI.Text color='black' size='base' className='mb-2'>
                  <Translation name='scores.fix_now'/>
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right'>
                  <Displays.Text name='fix_now'/>
                </UI.Text>
              </UI.SpaceBetween>
            </SmartviewText>
            <SmartviewText>
              <UI.SpaceBetween>
                <UI.Text color='black' size='base' className='mb-2'>
                  <Translation name='scores.warning'/>
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right'>
                  <Displays.Text name='warning'/>
                </UI.Text>
              </UI.SpaceBetween>
            </SmartviewText>
          </SmartviewTextGroup>
        </SmartviewContentSection>

        <ButtonWrap className='mt-10'>
          <Pipeline>
            <TriggerPipelineOnClick>
              <Button type='button'>
                <UI.WithIcon size={4} placement='right' icon={<UI.Icons.Eye/>}>
                  <Translation name='view_checkup'/>
                </UI.WithIcon>
              </Button>
            </TriggerPipelineOnClick>
            <NavigateOnPipe route='app.cleaning.perform_checkup' routeParameters={{ cleaning_checkup: 'model:id' }}/>
          </Pipeline>
        </ButtonWrap>
      </Smartview>
    </Translator>
  )
}
